import React, { createContext, useEffect, useRef, useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { Button, Card, CardBody, CardHeader, Col, Form, FormGroup, FormText, Input, Row } from 'reactstrap'

import { toast } from 'react-toastify'
import { notify } from '../../utils/notify'
import Email from '../../main/FormFields/Email'
import CharCheckModal from '../../components/molecules/CharCheckModal'
import TagsInput from '../../components/TagsInput'
import FileInput from '../../components/molecules/FileInput'
import ClienteSelect from '../../components/molecules/ClienteSelect'
import { useFileUpload } from '../../hooks'
import { api } from '../../utils'
import { estimateSemrushCost, readSemrushKeywords } from './semrushCostEstimate'

const EmailContext = createContext();

const SemRushForm = () => {
  const [keywords, setKeywords] = useState([])
  const [locations, setLocations] = useState([])
  const [file, setFiles] = useState(null)
  const [fileKeywords, setFileKeywords] = useState([])
  const [filePreviewError, setFilePreviewError] = useState('')
  const [fileLoading, setFileLoading] = useState(false)
  const [showCostConfirm, setShowCostConfirm] = useState(false)
  const filePreviewRequest = useRef(0)
  const [emails, setEmails] = useState([])
  const [location, setLocation] = useState('')
  const { upload, loading } = useFileUpload()
  const [clienti, setClienti] = useState([])
  const [selectedClientId, setSelectedClientId] = useState('')
		const [endpoint, setEndpoint] = useState('semrush-phrase-these')
	const [displayLimit, setDisplayLimit] = useState(0)
	const [endpoints] = useState([
		{value: 'semrush-phrase-these', label: 'Semrush - Batch Keyword Overview'},
		{value: 'semrush-related-keywords', label: 'Semrush - Related Keywords'},
		{value: 'semrush-broad-match-keyword', label: 'Semrush - Broad Match Keyword'},
		{value: 'semrush-phrase-questions', label: 'Semrush - Phrase Questions'}
	])
  // Modal check caratteri
  const [showCharCheck, setShowCharCheck] = useState(false)
  const [errCharList, setErrCharList] = useState([])
  const [acceptedCharCheck, setAcceptedCharCheck] = useState(false)

  const estimate = estimateSemrushCost([...fileKeywords, ...keywords], endpoint, displayLimit)
  const numberFormatter = new Intl.NumberFormat('it-IT')
  const euroFormatter = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' })

  const handleFileChange = async (selectedFile) => {
    const requestId = ++filePreviewRequest.current
    setFiles(selectedFile || null)
    setFileKeywords([])
    setFilePreviewError('')
    if (!selectedFile) {
      setFileLoading(false)
      return
    }

    setFileLoading(true)
    try {
      const parsedKeywords = await readSemrushKeywords(selectedFile)
      if (requestId === filePreviewRequest.current) setFileKeywords(parsedKeywords)
    } catch (error) {
      if (requestId === filePreviewRequest.current) {
        setFilePreviewError(error.message || 'Impossibile leggere il file.')
      }
    } finally {
      if (requestId === filePreviewRequest.current) setFileLoading(false)
    }
  }

  const handleSubmit = async (event, costConfirmed = false) => {
    if (event)
      event.preventDefault()

    let formData = new FormData()
    formData.append('keywords', keywords)
    formData.append('country', location)
    formData.append('emails', emails)
    formData.append('file', file)
    formData.append('endpoint', endpoint)
    formData.append('display-limit', displayLimit)
    acceptedCharCheck && formData.append('accepted', acceptedCharCheck)

	    if ((emails == '') || (file == null && keywords == '') || (endpoint !== "semrush-phrase-these" && displayLimit === 0)) {
	      notify(
	        'Mail, file, valore display limit o keyword mancanti',
	        'error'
	      )
	      return
	    }
    if (!selectedClientId) {
      notify('Seleziona un cliente.', 'error')
      return
    }
    if (
      endpoint !== 'semrush-phrase-these' &&
      (displayLimit === '' || !Number.isInteger(Number(displayLimit)) || Number(displayLimit) < 1 || Number(displayLimit) > 1000)
    ) {
      notify('Il display limit deve essere compreso tra 1 e 1.000.', 'error')
      return
    }
    if (fileLoading || filePreviewError || !estimate) {
      notify(filePreviewError || 'Attendi il calcolo della stima dei costi.', 'error')
      return
    }
    if (!costConfirmed) {
      setShowCostConfirm(true)
      return
    }
    setShowCostConfirm(false)

	    try {
        formData.append('cliente', selectedClientId)
	      await upload('post', 'sem-rush/', formData, {
	        onSuccess: (data) => {
          if (typeof data !== 'undefined') {
            notify("Report sent to " + emails.join(', '), 'success')
            setKeywords([])
	            setEmails([])
	            setFiles(null)
	            setFileKeywords([])
	            setEndpoint("semrush-phrase-these")
	            setDisplayLimit(0)
              setSelectedClientId('')
	          } else {
            notify(
              'Could not retrieve datas.',
              'success'
            )
            console.warn('Could not retrieve datas')
          }
        },
        onError: (errorMessage, err) => {
          if (err.response?.data?.message?.includes('ERROR Encoding keywords')) {
            setErrCharList(err.response.data?.errors)
            setShowCharCheck(true)
          } else {
            notify(
              err.response.data,
              'error'
            )
            setKeywords([])
            setEmails([])
            setFiles(null)
            setFileKeywords([])
            setEndpoint("semrush-phrase-these")
            setDisplayLimit(0)
          }
        },
      })
    } catch (err) {
      console.error('SemRush submission failed:', err)
    }
  }

    const selectedKeywords = keywords => {
    setKeywords(keywords)
  }

  useEffect(() => {
    api
      .get('clienti/')
      .then((response) => {
        setClienti(Array.isArray(response.data) ? response.data : response.data?.results || [])
      })
      .catch((err) => {
        console.error('Failed to fetch clienti', err)
      })
  }, [])

  useEffect(() => {
    let locations = ['it', 'fr', 'us', 'de', 'es', 'gb', 'pt']
    locations = Array.from(new Set(locations))
    setLocations(locations)
    setLocation('it')
    setDisplayLimit('0')
  },[])

  const confirmEvaluation = (e) => {
    e.preventDefault()
    setShowCharCheck(false)
    setAcceptedCharCheck(true)
  }

  useEffect(() => {
    if(acceptedCharCheck) {
      handleSubmit(null, true)
    }
  }, [acceptedCharCheck])

    return (
      <>
		<CharCheckModal
          show={showCharCheck}
          onHide={setShowCharCheck}
          onSubmit={confirmEvaluation}
          errCharList={errCharList}
          warningText="Sono stati rilevati caratteri sospetti nelle keyword. Vuoi continuare?"
        />
        <Modal show={showCostConfirm} onHide={() => setShowCostConfirm(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Stima del consumo API Semrush</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Con {numberFormatter.format(estimate?.keywordCount || 0)} keyword uniche userai al massimo{' '}
              {numberFormatter.format(estimate?.units || 0)} unità API, per un costo stimato fino a{' '}
              {euroFormatter.format(estimate?.euros || 0)}.
            </p>
            <p>
              Il consumo effettivo dipende dalle righe restituite da Semrush. Puoi ridurre il numero di
              keyword o il display limit prima di procedere.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button color="secondary" onClick={() => setShowCostConfirm(false)}>Modifica</Button>
            <Button color="primary" onClick={() => handleSubmit(null, true)}>Procedi</Button>
          </Modal.Footer>
        </Modal>
        {loading ? (
          <Spinner animation="grow" />
        ) : (
        <div className="col pb-5">
				<Card className="bg-secondary shadow">
					<CardHeader className="bg-white border-0">
						<Row style={{ marginLeft: "0px" }}>
							<Col md={10}>
								<h1 className="mb-0">SemRush</h1>
							</Col>
						</Row>
					</CardHeader>
	          <CardBody>
	          <Form onSubmit={handleSubmit} id="idea-form" action="">
	            <Row>
                <Col md={6}>
                  <ClienteSelect
                    id="semrush-cliente"
                    label="Cliente"
                    clienti={clienti}
                    selectedClientId={selectedClientId}
                    onChange={setSelectedClientId}
                    isRequired
                    showCreateLink
                  />
                </Col>
              </Row>
              <Row>
	              <Col md={6}>
	                <FileInput
	                  onFileChange={handleFileChange}
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  helpText={
                    <>
                      Carica un file contenente le tue keywords. <br />
                      <b>Il file deve contenere almeno una colonna "Keyword"</b>
                    </>
                  }
                  required={false}
                />
                {fileLoading && <FormText color="muted">Calcolo della stima in corso...</FormText>}
                {filePreviewError && <FormText color="danger">{filePreviewError}</FormText>}
                <FormGroup>
                  <label htmlFor="location" style={{ display: 'block' }}>
                    Location
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="location"
                    type="select"
                    value={location}
                    required
                    style={{ border: '0', height: '44px'}}
                    onChange={event => {
                      setLocation(event.target.value)
                    }}
                  >
                    {locations.map(location => {
                      return (
                        <option key={location} value={location}>
                          {location}
                        </option>
                      )
                    })}
                  </Input>
	                <FormText color="muted" align={'left'}>
										<br/>
									</FormText>
                </FormGroup>
	              <FormGroup required>
									<label htmlFor="endpoints" className="form-control-label">
										Endpoints
									</label>
									<Input
										className="form-control-alternative"
										type="select"
										id="project"
										value={endpoint}
										style={{ border: '0', height: '44px'}}
										onChange={e => setEndpoint(e.target.value)}
										required
									>
										{endpoints.map(m => (
											<option value={m.value} key={m.value}>
												{m.label}
											</option>
										))}
									</Input>
									<FormText color="muted" align={'left'}>
										Seleziona la piattaforma da cui recuperare i dati
									</FormText>
								</FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup required>
                  <label htmlFor="keyword" style={{ display: 'block' }}>
                    Keywords
                  </label>
                  <TagsInput
                    className="form-control-alternative"
										id='keywords'
										selectedTags={selectedKeywords}
										tags={keywords}
										type='text'
                    style={{ border: '0', height: '44px'}}
                  />

                  <FormText color="muted" align={'left'}>
                    Inserisci eventuali keywords aggiuntive. <br />
                    <b>Premi invio dopo ogni nuovo inserimento.</b>
                  </FormText>
                </FormGroup>
	              {(endpoint === "semrush-phrase-these") ? ("") : (
                <FormGroup>
                <label htmlFor="display-limit" className="form-control-label">
                  Display Limit
                </label>
                <Input
                  className="form-control-alternative"
                  id="display-limit"
                  type="number"
                  value={displayLimit}
                  onChange={event => {
                    const inputValue = event.target.value
                    // Allow empty input
                    if (inputValue === '') {
                      setDisplayLimit('')
                      return;
                    }
                    let numericValue = parseInt(inputValue, 10)
                    if (isNaN(numericValue)) {
                      numericValue = 50; // fallback to recommended value
                    }
                    if (numericValue < 1) {
                      numericValue = 1;
                      toast.error("Display limit cannot be less than 1. Setting to 1.")
                    } else if (numericValue > 1000) {
                      numericValue = 1000
                      toast.error("Display limit cannot exceed 1,000. Setting to 1,000.")
                    }
                    setDisplayLimit(numericValue)
                  }}
                  style={{ border: '0', height: '44px' }}
                  placeholder="50"
                  min="1"
                  max="1000"
                />
                <FormText color="muted" align="left">
                  <b>
                    Inserisci il numero massimo di keyword suggerite per ogni keyword in input
                  </b>
                  <br />
                  <b>
                    (valore compreso tra 1 e 1.000, consigliato: 50)
                  </b>
                </FormText>
              </FormGroup>)}
                <FormGroup>
                  <EmailContext.Provider value={{ emails, setEmails }}>
                    <Email context={EmailContext} />
                  </EmailContext.Provider>
                </FormGroup>
              </Col>
            </Row>
            {estimate && !fileLoading && !filePreviewError && (
              <div style={{ marginRight: '50px', textAlign: 'right' }}>
                <FormText color="muted">
                  Stima massima: {numberFormatter.format(estimate.units)} unità API ({' '}
                  {euroFormatter.format(estimate.euros)}) per {numberFormatter.format(estimate.keywordCount)}{' '}
                  keyword uniche. Il consumo reale dipende dai risultati restituiti.
                </FormText>
              </div>
            )}
            <Row style={{display: "flex", justifyContent: "flex-end", marginRight:"50px"}}>
            <Button color="info" size="lg" onClick={handleSubmit} >Submit Report</Button>
            </Row>          
          </Form>
          </CardBody>
				</Card>
				</div>
        )}
      </>
    )
}

export default SemRushForm
